var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"financial-metrics"},[_c('FinanceIndicator',{staticClass:"section-margin"}),_c('FinanceIncome',{staticClass:"section-margin",attrs:{"reportTypeMap":_vm.reportTypeMap}}),_c('FinanceBalance',{staticClass:"section-margin",attrs:{"reportTypeMap":_vm.reportTypeMap}}),_c('FinanceCash',{attrs:{"reportTypeMap":_vm.reportTypeMap}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }